import React from 'react';

const ErrorPage = () => {
 return (
  <div
   style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    justifyItems: 'center',
    margin: 'auto',
    textAlign: 'center',
    fontWeight: 800,
    fontSize: '24px',
    height: '100%',
    width: '100%',
    color: '#4a06ba',
    overflow: 'hidden',
    fontFamily: 'Montserrat',
   }}
  >
   <div
    style={{
     textAlign: 'center',
     fontWeight: 800,
     fontSize: '32px',
     width: 'calc(100%-80px)',
     color: '#4a06ba',
     paddingLeft: '40px',
     paddingRight: '40px',
     marginBottom: '20px',
    }}
   >
    Опаньки, запрашиваемая Вами страница не найдена...
   </div>

   <div
    style={{
     overflow: 'hidden',
     fontWeight: 800,
     fontSize: '160px',
     //width: '100%',
     color: '#4a06ba',
    }}
   >
    404
   </div>
  </div>
 );
};

export default ErrorPage;
